/*=============================================
	KAZZ-MATU_Action.js - 個別JS および jQuery実装
=============================================*/

/*=======================================================
	jq
========================================================*/
let w;
jQuery(function($){
	w = $(window);
	//scrollEvent();
	if(checkUA() == 'pc'){
		$('a[href^="tel"]').addClass('tel_dis').removeAttr('href')
	}
	if($('label').length){
		$('label').on('click',function(){});
		labelClick();
	}
	$('a[href^="#"]').on('click',function(e){
		let href= $(this).attr('href');
		let target = $(href == '#' || href == '' ? 'html' : href);
		let position = target.offset().top;
		let diff = 0;
		$('html,body').animate({scrollTop:position - diff}, 250);
		e.preventDefault();
	});
	spMenu();
  /*
  $('.top_item_list ul').addClass('owl-carousel').owlCarousel({
			items:4
   ,dots: false
			,margin:0
			,loop:true
			,nav:true
			,rewind:true
			,navText:['','']
			,navClass:['owl-prev','owl-next']
			,navContainerClass:"owl-nav",
			responsive : {
				0:{
					items:2,
					slideBy:2
				},
				768:{
					items:4,
					slideBy:4
				}
			}
  });
 */

	/*
	//スライダ
	if($('#image').length){
		topImage($('.main_image'),1000,1000,8500,0,true);
	}

	//カルーセル（個数制限）
	if( $('#image').length ){
  $('#image ul').addClass('owl-carousel').owlCarousel({
			items:3
			,margin:0
			,loop:true
			,nav:true
			,rewind:true
			,navText:['','']
			,navClass:['owl-prev','owl-next']
			,navContainerClass:"owl-nav",
			responsive : {
				0:{
					items:1,
					slideBy:1
				},
				768:{
					items:3,
					slideBy:3
				}
			}
  });
	}

	*/
});

function spMenu(){
	$('.btn_product').on('click',function(e){
		$('html').toggleClass('menu_on');
		e.preventDefault();
	});


	$('.btn_sp_menu').on('click',function(e){
		$('html').toggleClass('menu_on');
		e.preventDefault();
	});
 $('.btn_sp_menu_close').on('click',function(e){
		$('html').removeClass('menu_on');
		e.preventDefault();
	});

	$('.btn_h_search').on('click',function(e){
		$('html').toggleClass('search_area_on');
		e.preventDefault();
	});
 $('.btn_close_search').on('click',function(e){
		$('html').removeClass('search_area_on');
		e.preventDefault();
	});
}

function scrollEvent(){
	let st = 0;
	w.on('load resize scroll',function(){
		st = w.scrollTop();
		if(st >= 500){
			$('html').addClass('scr_on');
		}else{
			$('html').removeClass('scr_on');
		}
	});
}

function topImage(t,st,ft,dt,r,a){
	let img = t;
	let mark;
	let mh;
	
	let startTime = st; //1000;
	let fadeTime = ft;//1000;
	let delayTime = dt;//8500;
	let autoFlg = a;//true;
	let currentNo = 0;
	let oldNo = 0;
	let imageLength;
	let tid;

	imageLength = img.find('li').length;
	img.append('<span class="mark_p"></span><span class="mark_n"></span><p class="mark"></p>');
	mark = img.find('.mark');
	img.find('li').hide();

	t.find('li').each(function(index) {
		mark.append('<span>●</span>');
	});
	
	mark.find('span').each(function(index) {
		$(this).on('click',function(){
			clearInterval(tid);
			oldNo = currentNo;
			currentNo = index;
			changeNews();		
		});
	});

	mark.find('span').eq(0).addClass('on');

	t.find('.mark_n').on('click',function(){ changeTopImage(1);clearInterval(tid); });
	t.find('.mark_p').on('click',function(){ changeTopImage(2);clearInterval(tid); });	

	function changeTopImage(m){
		oldNo = currentNo;
		if(m==1){
			currentNo++;
			if(currentNo > (imageLength - 1)){
				currentNo = 0;	
			}
			changeNews();
		}else{
			currentNo--;
			if(currentNo <= -1){
				currentNo = imageLength - 1;	
			}
			changeNews();
		}
	}

	function changeNews(){
		img.find('li').eq(oldNo).fadeOut(fadeTime,function(){
			mark.find('span').removeClass('on');
			mark.find('span').eq(currentNo).addClass('on');
		});
		img.find('li').eq(currentNo).fadeIn(fadeTime);
	}

 //start
 mark.find('span').eq(0).addClass('on');
 img.find('li').eq(0).delay(startTime).fadeIn(fadeTime,function(){
  if (autoFlg) tid = setInterval(function(){
   oldNo = currentNo;
   currentNo++;
   if (currentNo >= imageLength)
   {
    currentNo = 0;
   }
   changeNews();	

  },delayTime);		
 });

}

function labelClick(){
	let radio = $('label');

	radio.each(function(){
		if ($(this).find('input').prop('checked')) {
			$(this).addClass('checked');
		}
	});

	radio.click(function(){
		radio.each(function(){
			if ($(this).find('input').prop('checked')) {
				$(this).addClass('checked');
			}else{
				$(this).removeClass('checked');
			}
		});
	});
}

function checkUA(){
	if((navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0 || navigator.userAgent.indexOf('iPad') > 0){
		return 'tb';
	} else if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
		return 'sp';
	}else{
		return 'pc';
	}
}